import { FC, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollTop: FC<React.PropsWithChildren<{}>> = props => {
  const { children } = props;

  const scrollTopRef = useRef(null);

  const location = useLocation();

  useEffect(() => {
    scrollTopRef.current.scrollIntoView();
  }, [location]);

  return (
    <>
      <div ref={scrollTopRef} />
      {children}
    </>
  );
};

export default ScrollTop;
